var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSummaryPeople = function SvgIconSummaryPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.305 19.675c2.718 0 4.922-2.243 4.922-5.01s-2.204-5.01-4.922-5.01c-2.719 0-4.922 2.243-4.922 5.01s2.204 5.01 4.922 5.01ZM23.962 30.438H8.65a1.437 1.437 0 0 1-1.118-.533 1.494 1.494 0 0 1-.316-1.215c.773-4.56 4.548-7.715 9.09-7.715 4.544 0 8.32 3.154 9.094 7.715a1.51 1.51 0 0 1-.317 1.216 1.437 1.437 0 0 1-1.12.532Z",
    fill: "#94C6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.785 19.675c2.719 0 4.922-2.243 4.922-5.01s-2.203-5.01-4.922-5.01c-2.718 0-4.922 2.243-4.922 5.01s2.204 5.01 4.922 5.01ZM33.441 30.438H18.128a1.437 1.437 0 0 1-1.119-.533 1.494 1.494 0 0 1-.316-1.215c.773-4.56 4.548-7.715 9.091-7.715 4.543 0 8.319 3.154 9.094 7.715a1.51 1.51 0 0 1-.317 1.216 1.437 1.437 0 0 1-1.12.532Z",
    fill: "#3987F8"
  })));
};
export default SvgIconSummaryPeople;